
import {ACTION} from './constants';


let initialState={
};

export default function cookiePolicyReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_COOKIE_POLICY_CONTENT :
            return {...state, list:action.data, apiLoaded:true};
        default:
            return state;
    }
}
